import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { IModGroupParentItem, RestaurantModGroupPropertiesType } from 'types';
import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import { Badge } from 'components/Badge';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './ParentsList.module.scss';

interface IProps {
	parents: IModGroupParentItem[];
	onClickEditInclusive: () => void;
	isDisabled?: boolean;
	isPortionFlow?: boolean;
}

export const ParentsList: React.FC<IProps> = React.memo(
	({ parents, onClickEditInclusive, isDisabled, isPortionFlow }) => {
		const getElementLink = useCallback((id: string, type: RestaurantModGroupPropertiesType): Nullable<string> => {
			if (
				type === RestaurantModGroupPropertiesType.Dish ||
				type === RestaurantModGroupPropertiesType.DishAndModifier
			) {
				return `/menu-v2/dishes/view?dishID=${id}`;
			}
			if (type === RestaurantModGroupPropertiesType.Modifier) {
				return `/menu-v2/modifiers/view?modifierID=${id}`;
			}
			return null;
		}, []);

		return (
			<>
				{parents.length > 0 ? (
					<div className={style.list}>
						{parents.map((parent) => {
							const parentLink = getElementLink(parent.id, parent.type);
							return (
								<div key={parent.id} className={style.itemWrapper}>
									<div className={style.dot} />
									{parentLink ? (
										<Link
											className={style.link}
											target={`blank_${Date.now()}`}
											rel="noopener noreferrer"
											to={parentLink}>
											<Text
												className={style.name}
												translationKey={parent.name}
												size="s"
												withTooltip={true}
											/>
										</Link>
									) : (
										<Text
											className={style.name}
											translationKey={parent.name}
											size="s"
											withTooltip={true}
										/>
									)}
									{parent.inclusive > 0 && (
										<Badge className={style.badge} color="green">
											<Text
												translationNameSpace="form"
												translationKey="inclusiveLabel"
												asFragment={true}
											/>
										</Badge>
									)}
								</div>
							);
						})}
					</div>
				) : (
					<Text translationNameSpace="form" translationKey="noElementsIncludeThisGroup" size="s" />
				)}
				{!isPortionFlow && (
					<Button
						className={style.editBtn}
						data-testid="editInclusiveBtn"
						size="sizeS"
						theme="outlined"
						onClick={onClickEditInclusive}
						disabled={isDisabled || parents.length === 0}
						icon={
							<svg className={style.icon}>
								<use xlinkHref={`${breadcrumbs}#pencil`} />
							</svg>
						}>
						<Text translationNameSpace="form" translationKey="editInclusiveButton" asFragment={true} />
					</Button>
				)}
			</>
		);
	},
);
